import { render } from "./AnimatedNumber.vue?vue&type=template&id=5f756228&scoped=true"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"

import "./AnimatedNumber.vue?vue&type=style&index=0&id=5f756228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f756228"]])

export default __exports__